import React, { useEffect, useState } from "react";
import { Card, Label } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  thirdPartyXeroAssignTenant,
  thirdPartyXeroCheckStatus,
  thirdPartyXeroGenerateAccessToken,
  thirdPartyXeroUnassignTenant,
  thirdPartyXeroUnassignTenantSuccess,
} from "../../../../store/thirdPartyIntegration/action";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import Select from "react-select";
import LoadingSpinner from "../../../../Components/Common/Spinner";
import connectToXero from "../../../../assets/images/svg/xeroBranding/connect-xero.svg";
import disconnectFromXero from "../../../../assets/images/svg/xeroBranding/disconnect-xero.svg";

export default function XeroIntegration() {
  const dispatch = useDispatch();
  const params = useParams();
  const codeParam = params?.code;

  const [extractedCode, setExtractedCode] = useState(codeParam || null);
  const [assignTenant, setAssignTenant] = useState(false);
  const [syncData, setSyncData] = useState({
    TenantId: "",
    SyncDirection: "both",
    SyncInterval: "1",
    FlagSyncCustomers: "1",
    FlagSyncInvoices: "0",
    FlagSyncProducts: "0",
  });

  const {
    thirdPartyXeroCheckStatusDataAPI,
    thirdPartyXeroCheckStatusLoading,
    thirdPartyXeroUnassignTenantDataAPI,
    thirdPartyXeroGenerateAccessTokenDataAPI,
    thirdPartyXeroAssignTenantDataAPI,
  } = useSelector((state) => ({
    thirdPartyXeroCheckStatusDataAPI:
      state.ThirdPartyIntegration.thirdPartyXeroCheckStatusData,
    thirdPartyXeroCheckStatusLoading:
      state.ThirdPartyIntegration.thirdPartyXeroCheckStatusLoading,
    thirdPartyXeroUnassignTenantDataAPI:
      state.ThirdPartyIntegration.thirdPartyXeroUnassignTenantData,
    thirdPartyXeroGenerateAccessTokenDataAPI:
      state.ThirdPartyIntegration.thirdPartyXeroGenerateAccessTokenData,
    thirdPartyXeroAssignTenantDataAPI:
      state.ThirdPartyIntegration.thirdPartyXeroAssignTenantData,
  }));

  const currentDomainName =
    window.location.hostname === "localhost"
      ? "localhost:3000"
      : window.location.hostname;
  const httpOrHttps =
    window.location.protocol === "https:" ? "https%3A%2F%2F" : "http%3A%2F%2F";
  const combinedDomainName = httpOrHttps + currentDomainName;
  const RedirectUrl =
    (window.location.protocol === "https:" ? "https://" : "http://") +
    currentDomainName +
    "/settings/1/27/xero/code";

  const xeroAuthLoginUrl =
    "https://login.xero.com/identity/connect/authorize?response_type=code&client_id=82A6CDAF03D64755910DC37336C820D4&redirect_uri=" +
    combinedDomainName +
    "%2Fsettings%2F1%2F27%2Fxero%2Fcode" +
    "&scope=openid%20profile%20email%20offline_access%20accounting.transactions%20accounting.contacts%20accounting.settings&state=123";

  useEffect(() => {
    dispatch(thirdPartyXeroCheckStatus());
  }, []);

  useEffect(() => {
    if (!extractedCode) return;
    dispatch(
      thirdPartyXeroGenerateAccessToken([{ Code: extractedCode, RedirectUrl }])
    );
  }, [extractedCode]);

  useEffect(() => {
    if (isEmpty(thirdPartyXeroUnassignTenantDataAPI)) return;
    if (thirdPartyXeroUnassignTenantDataAPI.status === 200) {
      toast.success(thirdPartyXeroUnassignTenantDataAPI?.message);
      dispatch(thirdPartyXeroCheckStatus());
    } else {
      toast.error(thirdPartyXeroUnassignTenantDataAPI?.message);
    }
    dispatch(thirdPartyXeroUnassignTenantSuccess([]));
  }, [thirdPartyXeroUnassignTenantDataAPI]);

  useEffect(() => {
    if (isEmpty(thirdPartyXeroGenerateAccessTokenDataAPI)) return;
    if (thirdPartyXeroGenerateAccessTokenDataAPI.status === 200) {
      toast.success(thirdPartyXeroGenerateAccessTokenDataAPI?.message);
      setExtractedCode(null);
      setAssignTenant(true);
    } else {
      toast.error(thirdPartyXeroGenerateAccessTokenDataAPI?.message);
    }
  }, [thirdPartyXeroGenerateAccessTokenDataAPI]);

  useEffect(() => {
    if (isEmpty(thirdPartyXeroAssignTenantDataAPI)) return;
    if (thirdPartyXeroAssignTenantDataAPI.status === 200) {
      toast.success(thirdPartyXeroAssignTenantDataAPI?.message);
      setAssignTenant(false);
      dispatch(thirdPartyXeroCheckStatus());
    } else {
      toast.error(thirdPartyXeroAssignTenantDataAPI?.message);
    }
  }, [thirdPartyXeroAssignTenantDataAPI]);

  const handleCancelConnection = () => {
    dispatch(thirdPartyXeroUnassignTenant());
  };

  const handleIntegrationConnect = () => {
    window.location.href = xeroAuthLoginUrl;
  };

  const handleAssignment = () => {
    dispatch(thirdPartyXeroAssignTenant([syncData]));
  };

  const syncDirection = [
    { label: "Both", value: "both" },
    { label: "CRMIT to Xero", value: "crmit_to_xero" },
    { label: "Xero to CRMIT", value: "xero_to_crmit" },
  ];

  const syncInterval = [
    { label: "Every Hour", value: "1" },
    { label: "Every 4 Hours", value: "2" },
    { label: "Every 6 Hours", value: "3" },
    { label: "Every 12 Hours", value: "4" },
    { label: "Every 24 Hours", value: "5" },
  ];

  if (thirdPartyXeroCheckStatusLoading) return <LoadingSpinner />;

  return (
    <>
      {thirdPartyXeroCheckStatusDataAPI.status === 200 && (
        <Card className="p-2">
          {extractedCode ? (
            <h5>Processing please wait...</h5>
          ) : assignTenant ? (
            <>
              <h5>Configure your business connection settings</h5>
              <Label>Select Tenant</Label>
              <Select
                placeholder="Select Tenant"
                options={
                  thirdPartyXeroGenerateAccessTokenDataAPI?.tenants?.map(
                    (option) => ({
                      label: option?.BusinessName,
                      value: option?.TenantId,
                    })
                  ) || []
                }
                value={
                  syncData.TenantId
                    ? {
                        label:
                          thirdPartyXeroGenerateAccessTokenDataAPI?.tenants?.find(
                            (opt) => opt?.TenantId === syncData.TenantId
                          )?.BusinessName,
                        value: syncData.TenantId,
                      }
                    : null
                }
                onChange={(e) =>
                  setSyncData({ ...syncData, TenantId: e.value })
                }
              />
              <Label className="mt-2">Sync Direction</Label>
              <Select
                options={syncDirection}
                value={syncDirection.find(
                  (o) => o.value === syncData.SyncDirection
                )}
                onChange={(e) =>
                  setSyncData({ ...syncData, SyncDirection: e.value })
                }
              />
              <Label className="mt-2">Sync Interval</Label>
              <Select
                options={syncInterval}
                value={syncInterval.find(
                  (o) => o.value === syncData.SyncInterval
                )}
                onChange={(e) =>
                  setSyncData({ ...syncData, SyncInterval: e.value })
                }
              />
              <div className="mt-2">
                <input
                  type="checkbox"
                  checked={syncData.FlagSyncCustomers === "1"}
                  onChange={(e) =>
                    setSyncData({
                      ...syncData,
                      FlagSyncCustomers: e.target.checked ? "1" : "0",
                    })
                  }
                />
                <Label className="ms-2">Synchronise Customers</Label>
              </div>
              <div>
                <input
                  type="checkbox"
                  checked={syncData.FlagSyncInvoices === "1"}
                  onChange={(e) =>
                    setSyncData({
                      ...syncData,
                      FlagSyncInvoices: e.target.checked ? "1" : "0",
                    })
                  }
                />
                <Label className="ms-2">Synchronise Invoices</Label>
              </div>
              <div>
                <input
                  type="checkbox"
                  checked={syncData.FlagSyncProducts === "1"}
                  onChange={(e) =>
                    setSyncData({
                      ...syncData,
                      FlagSyncProducts: e.target.checked ? "1" : "0",
                    })
                  }
                />
                <Label className="ms-2">Sync Products (Items)</Label>
              </div>
              <button
                className="btn btn-success w-100 mt-2"
                onClick={handleAssignment}
              >
                Synchronise
              </button>
            </>
          ) : (
            <>
              <h5>
                Current Integration Status:{" "}
                {thirdPartyXeroCheckStatusDataAPI?.message}
              </h5>
              {thirdPartyXeroCheckStatusDataAPI?.syncstatus === 1 ? (
                <button
                  title="Disconnect from Xero"
                  className="btn"
                  style={{
                    backgroundImage: `url(${disconnectFromXero})`,
                    backgroundRepeat: "no-repeat",
                    width: "230px",
                    height: "50px",
                  }}
                  onClick={handleCancelConnection}
                />
              ) : (
                <button
                  title="Connect to Xero"
                  className="btn"
                  style={{
                    backgroundImage: `url(${connectToXero})`,
                    backgroundRepeat: "no-repeat",
                    width: "230px",
                    height: "50px",
                  }}
                  onClick={handleIntegrationConnect}
                />
              )}
            </>
          )}
        </Card>
      )}
    </>
  );
}
